import { defineMessages } from 'react-intl';

export default defineMessages({
  profile: {
    id: 'PayAsYouGo.profile',
    defaultMessage: 'Pay-As-You-Go Profile',
  },
  active: {
    id: 'PayAsYouGo.active',
    defaultMessage: 'Active',
  },
  blocked: {
    id: 'PayAsYouGo.blocked',
    defaultMessage: 'Blocked',
  },
  blockProfile: {
    id: 'PayAsYouGo.blockProfile',
    defaultMessage: 'Block profile',
  },
  emailDispute: {
    id: 'PayAsYouGo.emailDispute',
    defaultMessage: 'Email dispute instructions',
  },
});
